import { useEffect } from "react";

export default function useImagePreload(images: string[]) {
    useEffect(() => {
        images.forEach((image) => {
            const img = new Image();
            img.src = new URL(image, window.location.origin).href;
        });
    }, [images]);
}